<ng-icon
  [name]="value || iconAlwaysFilled() ? iconFilled() : iconOutline()"
  [size]="iconSize()"
  [class]="iconSizeClass() + (isDesignSystem() || readonly() || isLoading ? '' : ' hover:text-yellow-500')"
  [class.text-yellow-500]="!isDesignSystem() && (value || iconAlwaysFilled())"
  [style.color]="!isDesignSystem() && !value && !iconAlwaysFilled() && !dark() ? '#c4c8d4' : null"
  [class.svz-bookmark-on]="isDesignSystem() && (value || iconAlwaysFilled())"
  [class.svz-bookmark-off]="isDesignSystem() && !value && !iconAlwaysFilled() && !dark()"
  [class.text-white]="!value && !iconAlwaysFilled() && dark()"
  [zTooltip]="(readonly() || isLoading) ? null : ((value ? removeLabel() : addLabel()) | transloco)"
  [attr.aria-label]="(value ? removeLabel() : addLabel()) | transloco"
></ng-icon>
